import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e19ff20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "align-items-center container d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-4" }, "Contactos", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contactos__map" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1999.2862811147872!2d30.342809316210914!3d59.927391669967776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43933d4cf79bdce1%3A0xd4a24c121240d17a!2z0KbQtdC90YLRgCDQuNGB0L_QsNC90YHQutC-0LPQviDRj9C30YvQutCwIENlbnRybyBQaWNhc3Nv!5e0!3m2!1sru!2ses!4v1638910699219!5m2!1sru!2ses",
    width: "500",
    height: "500",
    style: {"border":"0"},
    allowfullscreen: "false",
    loading: "lazy",
    title: "Google map with location"
  })
], -1))
const _hoisted_4 = { class: "container mt-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Enviar")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container font-weight-bold m-3 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("em", { class: "fas fa-map-marker m-3" }),
    /*#__PURE__*/_createElementVNode("span", null, "Zagorodnyi prosp., 5")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("em", { class: "fas fa-phone-alt m-3" }),
    /*#__PURE__*/_createElementVNode("span", null, "+7 (911) 844 26 28")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("em", { class: "fas fa-envelope m-3" }),
    /*#__PURE__*/_createElementVNode("span", null, "info@centropicasso.ru")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_b_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_form_group, {
            "label-cols-lg": "3",
            label: "Nombre",
            "label-for": "input-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                placeholder: "Nombre",
                id: "input-name"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_form_group, {
            "label-cols-lg": "3",
            label: "Teléfono",
            "label-for": "input-phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                placeholder: "Teléfono",
                id: "input-phone"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_form_group, {
            "label-cols-lg": "3",
            label: "Email",
            "label-for": "input-email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                placeholder: "Email",
                id: "input-email"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_form_group, {
            "label-cols-lg": "3",
            label: "Tema",
            "label-for": "input-tema"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                placeholder: "Tema",
                id: "input-tema"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_form_textarea, {
            size: "lg",
            id: "input-message",
            type: "textarea",
            trim: "",
            placeholder: "Mensaje",
            rows: "6",
            "no-resize": ""
          }),
          _createVNode(_component_b_button, {
            class: "send-button m-3",
            pill: ""
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_6
    ])
  ]))
}